import { render, staticRenderFns } from "./DiagnosisOverview.vue?vue&type=template&id=faf6ffd0&"
import script from "./DiagnosisOverview.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf6ffd0')) {
      api.createRecord('faf6ffd0', component.options)
    } else {
      api.reload('faf6ffd0', component.options)
    }
    module.hot.accept("./DiagnosisOverview.vue?vue&type=template&id=faf6ffd0&", function () {
      api.rerender('faf6ffd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/DiagnosisOverview.vue"
export default component.exports